
import request from "../request";
import publicVar from "../publicData/global_variable";

let appHasWeixin = 0;  // 是否是微信
let isHuawei = 0;      // 是否是华为包
let isOppo = 0;        // 是否是 oppo 包
let orderId;           // 订单 ID
const paramData = {
    payWay: "0",
    ip: "10.10.34.124",
    orderSource: "0",
    sourceToken: "3279E5AE"
}

/**
 * weixin 中， 使用 JS_SDK
 * @param {object} paramsObj   调用支付方法时的所有参数
 */
const weixinPay = (paramsObj) => {
    const url = "/course/order/placeOrder";

    request(url, Object.assign({}, paramData, paramsObj && paramsObj.data ? paramsObj.data : {}), { "method": "GET" })
        .then(res => res.json())
        .then((res) => {
            if (res.result === "SUCCESS" || res.code === 200) {
                // 使用微信 JS-SDK
                window.wx.ready(function () {
                    window.chooseWXPay({
                        timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
                        package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: res.data.sign, // 支付签名
                        appId: res.data.appId,
                        success: function () {
                            // 查询支付结果
                            if (res.data && res.data.orderId) {
                                window.handlePay.orderId = res.data.orderId;
                            }
                            queryPayResult();
                        }
                    });
                });
            } else {
                if (window.PuTaoA && window.PuTaoA.showTips) {
                    window.PuTaoA.showTips(res.msg ? res.msg : "数据异常，请重试");
                }
                try {
                    window.PTMonitor.report({
                        type: 'apiSucEx',
                        url: window.location.href,
                        info: res,
                        stack: url
                    }, window.EX_TYPE.apiSucEx);
                } catch (err) { }

            }
        })
        .catch((err) => {
            if (window.PuTaoA && window.PuTaoA.hideCommonLoading) {
                window.PuTaoA.hideCommonLoading();
            }
            try {
                window.PTMonitor.report({
                    type: 'apiEx',
                    url: window.location.href,
                    info: err,
                    stack: url
                }, window.EX_TYPE.apiEx);
            } catch (err) { }
        });
}

/**
 * ios 中
 * @param {object} paramsObj  调用支付方法时的所有参数
 */
const appIosPay = (paramsObj) => {
    const paramString = JSON.stringify(paramsObj && paramsObj.data ? paramsObj.data : {});

    if (window.purchaseGroup) {
        window.purchaseGroup(paramString);
    }
    // else if (window.webkit && window.webkit.messageHandlers && window.PuTaoA && window.PuTaoA.ios8IntoVariable) {
    //     window.PuTaoA.ios8IntoVariable("purchaseGroup", paramString);
    // }
}

/**
 * 非 ios 中，根据不同的包，走不同的支付方式（url 不同）
 * @param {object} paramsObj  调用支付方法时的所有参数
 */
const appPay = (paramsObj) => {
    if (window.android && window.android.getAppHasWeixin) {             // 是否是微信（IOS 走内购，不需要判断是否安装了微信）
        appHasWeixin = parseInt(window.android.getAppHasWeixin(), 10);
    }

    if (window.android && window.android.getIsHuaweiPay) {            // 防止刚进页面获取不到是否是华为包，这边点击的时候再主动获取一次
        isHuawei = parseInt(window.android.getIsHuaweiPay(), 10);
    }

    if (window.android && window.android.getIsOppoPay) {
        isOppo = parseInt(window.android.getIsOppoPay(), 10);
    }

    let url;
    // 不同包请求的地址不同
    if (isHuawei) {
        url = "/course/order/app/huawei/placeOrder";
    } else if (isOppo) {
        url = "/course/order/app/oppo/placeOrder";
    } else {
        url = "/course/order/app/andr/placeOrder?tradeType=" + (appHasWeixin ? 2 : 1);    // 1-二维码支付 2-调起微信支付
    }

    request(url, Object.assign({}, paramData, paramsObj && paramsObj.data ? paramsObj.data : {}), { "method": "GET" })
        .then(res => res.json())
        .then((res) => {
            if (res.result === "SUCCESS" || res.code === 200) {
                if (res.data) {
                    if (res.data.orderId) {
                        orderId = res.data.orderId;
                    }

                    // 不同包调用的方法不同
                    if (isHuawei) {
                        callAppPay("hwPay", JSON.stringify(res.data));
                    } else if (isOppo) {
                        callAppPay("oppoPay", JSON.stringify(res.data));
                    } else if (appHasWeixin) {
                        callAppPay("wxPay", JSON.stringify(res.data));
                    } else {
                        queryPayResult();
                        if (window.commonBuy.qrcodeCallback) {
                            window.commonBuy.qrcodeCallback(res);
                        }
                    }
                }
            } else {
                if (window.PuTaoA && window.PuTaoA.showTips) {
                    window.PuTaoA.showTips(res.msg ? res.msg : "数据异常，请重试");
                }
                try {
                    window.PTMonitor.report({
                        type: 'apiSucEx',
                        url: window.location.href,
                        info: res,
                        stack: url
                    }, window.EX_TYPE.apiSucEx);
                } catch (err) { }

            }
        })
        .catch((err) => {
            if (window.PuTaoA && window.PuTaoA.hideCommonLoading) {
                window.PuTaoA.hideCommonLoading();
            }
            try {
                window.PTMonitor.report({
                    type: 'apiEx',
                    url: window.location.href,
                    info: err,
                    stack: url
                }, window.EX_TYPE.apiEx);
            } catch (err) { }
        });
}


/**
 * 查询支付结果
 */
const queryPayResult = () => {
    const url = "/course/order/pay/queryPayResult";

    request(url, { orderId: orderId }, { method: "GET" })
        .then(res => res.json())
        .then(res => {
            if (res.result === "SUCCESS") {
                if (publicVar.isWx || (res.data && res.data.state && parseInt(res.data.state, 10) === 1)) {
                    window.commonBuy.paySuccess(res);
                } else {
                    if (window.commonBuy.payPending) {
                        window.commonBuy.payPending(res);
                    }

                    setTimeout(function () {
                        queryPayResult();
                    }, 1000);
                }
            }
        });
}

/**
 * 给 app 提供的支付成功的回调
 * @param {string} orderId  订单 id（ios 中，是 ios 去请求接口的，我们这边不知道 orderId,所以需要传过来）
 */
window.paySuccess = function (id) {
    if (id) {
        orderId = id;
    }

    queryPayResult();  // 查询结果 
};

/**
 * 非 ios 中，根据不同的包，走不同的支付方式（url 不同）
 * @param {object} paramsObj  调用支付方法时的所有参数
 */
const callAppPay = (funName, param) => {
    if (window.android && window.android[funName]) {
        window.android[funName](param);
    } else {
        console.log(`error: ${funName} is not a function`)
    }
}

export { weixinPay, appIosPay, appPay };


// WEBPACK FOOTER //
// ./src/lib/JSBridge/buyFun.js